import { Component, Input } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'c-icon',
  templateUrl: 'icon.html',
  styleUrls:['icon.scss']
})
export class IconComponent {
    
    @Input() src : string; 

    constructor(
        public utils: UtilsService    
    ) {}
    
    assembleIconLink( assetPath: string) : string {
        // icons are fetched from the backend 
        // so make sure that you have icons added asset folder
        return this.utils.getCDNAsset('icon/' + assetPath);
    }
}